/**
 * Whats New Modal constants.
 * Numeric and configuration values used by the modal and its hooks.
 */

/** Maximum number of unseen releases to show in the modal at once. */
export const MAX_RELEASES_TO_SHOW = 3;

/** Number of days after which stored release "seen" entries are pruned from localStorage. */
export const PRUNE_DAYS = 30;
